<template>
   <v-container
      class="pa-2"
      fluid

      v-if="resources.length > 0">
      
      <v-row>
        <v-col cols="12">
          <div class="row mx-1 title">Resources</div>
        </v-col>
      </v-row>

      <v-row>
        
        <v-col
          v-for="card in resources"
          :key="card.title"
          :cols="card.flex"
        >

        <v-card
        class="mx-auto"
        max-width="344"
        flat  
      >
        <v-list-item three-line>
          <v-list-item-content>
            <router-link :to="'/resources/'+card.url">
              <v-list-item-title class="title my-3" v-text="card.title"></v-list-item-title>
            </router-link>
            <span class="font-weight-light">
                {{card.desc}}
            </span>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-card-actions>
            <div class="flex-grow-1"></div>

          <v-btn  color="primary" outlined tile text right>Read</v-btn>
        </v-card-actions> -->
      </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>
<script>

export default {
    props: {
      resources: {
            type: Array,
            required: false
        }
    },
    data: () => ({
    }),
    methods: {
    }
}
</script>